import React from 'react';
import { Text } from '@pairy/pds-react';

import * as Styled from './index.styles';

interface Props {
  file: File;
  filename: string;
  onClickChangeFile: () => void;
}

const Preview = ({ file, filename, onClickChangeFile }: Props) => {
  const fileUrl = React.useMemo(() => URL.createObjectURL(file), [filename]);

  return (
    <Styled.Wrapper>
      <Styled.FileNameWrapper className="hover">
        <Text variant="md-medium" color="zinc_400">
          {filename}
        </Text>
      </Styled.FileNameWrapper>
      <Styled.ButtonFileChange
        className="hover"
        variant="skyblue_400_fill"
        paddingY={8}
        paddingX={12}
        radius={4}
        textVariant="sm-regular"
        onClick={onClickChangeFile}
      >
        파일 변경
      </Styled.ButtonFileChange>
      <Styled.FlexPdfViewerWrapper justifyContent="center">
        <iframe
          src={`${fileUrl}#toolbar=0&navpanes=0&scrollbar=0`}
          width={530}
          height={289}
        />
      </Styled.FlexPdfViewerWrapper>
    </Styled.Wrapper>
  );
};

export default React.memo(Preview);
